module.exports = __webpack_public_path__ + "img/invoice-at-male.b24f3758.png";